module.exports = __webpack_public_path__ + "static/scale-model-of-morean-glass-studio-in-st.-petersburg-florida-f45731cc1f37de322f217264bdc8403d.png";